module.exports = __webpack_public_path__ + "static/media/userRoleIcon.85826e77.svg";